<template>
    <footer class="footer has-cards">
        <div class="container">
            <div class="row row-grid align-items-center my-md">
                <div class="col-lg-6">
                    <h3 class="text-primary font-weight-light mb-2">Informasikan kebutuhan anda kepada Kami!</h3>
                    <h4 class="mb-0 font-weight-light">Let's us help your needs! </h4>
                </div>
                <div class="col-lg-6 text-lg-center btn-wrapper">
                     <div class="btn-wrapper">
                                  <base-button block type="default" class=" mb-3" @click="modals.modal_proposal = true">
                                Request A Proposal
                                </base-button>
                    </div>
                    <modal :show.sync="modals.modal_proposal"
                           body-classes="p-0"
                           modal-classes="modal-dialog-centered modal-lg">
                             <h6 slot="header" class="modal-title" id="modal-title-notification">Request a Proposal!</h6>
                        <card type="secondary" shadow
                              header-classes="bg-white pb-12"
                              body-classes="px-lg-12 py-lg-12"
                              class="border-0">

                            <template>
                                <div class="text-center text-muted mb-4">
                                    <small>Mohon isi data di bawah ini dengan lengkap untuk memesan jasa dan produk kami.</small>
                                </div>
                                <form role="form">
                                    <div class="row">
                                        <div class="col-md-6">
                                             <base-input required
                                                    class="mb-3"
                                                    placeholder="Nama Anda"
                                                    v-model.lazy ="client.nama"
                                                    addon-left-icon="ni ni-circle-08">
                                            </base-input>
                                        </div>
                                        <div class="col-md-6">
                                               <base-input required
                                                    class="mb-3"
                                                    placeholder="Email Anda"
                                                    v-model.lazy = 'client.email'
                                                    addon-left-icon="ni ni-email-83">
                                                </base-input>
                                        </div>
                                      
                                    </div>

                                    <textarea class="form-control" id="exampleFormControlTextarea1" rows="3" placeholder="Deskripsi singkat tentang project Anda" v-model.lazy='client.deskripsi' required ></textarea>

                                    <div class="text-center">
                                        <base-button type="primary" class="my-4" v-on:click="create_pesanan()">Request</base-button>
                                    </div>
                                </form>
                                <div class="text-center text-muted mb-4">
                                    <small> Kami akan menghubungi Anda lebih lanjut via email tentang projek Anda. Terima kasih.</small>
                                </div>
                            </template>
                        </card>
                    </modal>
                
                </div>
            </div>
            <hr>
            <div class="row align-items-center justify-content-md-between">
                <div class="col-md-6">
                    <div class="copyright">
                        &copy; {{year}}
                        <a href="https://zeroinside.net" target="_blank" rel="noopener">ZeroInside</a> </a>
                    </div>
                </div>
                <div class="col-md-6">
                  <ul class="nav nav-footer justify-content-end">
                    <li class="nav-item">
                      <a href="https://satrya.zeroinside.net" target="_blank" rel="noopener" class="nav-link">Made with <span class="fa fa-heartbeat" style="color:#f66767"></span> in Bandung</a>
                    </li>
                  </ul>
                </div>
            </div>
        </div>
    </footer>
</template>
<script>
import Modal from "@/components/Modal.vue";
import axios from "axios";
import swal from 'sweetalert';
import qs from 'querystring';

var axios_zeroinside = axios.create({
  baseURL: 'https://admin.zeroinside.net/',
  timeout: 1000
});

var axios_localhost = axios.create({
  baseURL: 'localhost/api/',
  timeout: 1000
});

export default {
  name: 'app-footer',
  components: {
        Modal
  },
  data() {
    return {
      year: new Date().getFullYear() ,
      modals: {
        modal_proposal: false
      },
      client : {
        nama : '',
        email : '',
        deskripsi : ''
      }
    }
  },
  methods : {
    create_pesanan() {
      // cek form kosong
      if(this.client.nama != '' && this.client.email != '' && this.client.deskripsi != '' ){
        // cek valid email
        if(this.validEmail(this.client.email)) {
          let api_url = 'https://admin.zeroinside.net/api/pesanan/add';
          let axiosConfig = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            crossDomain: true
          };
          // gunain stringfy rubah object ke string untuk tipe application/x-www-form-urlencoded. content type : json application ga bisa diterima diserver
          axios.post(api_url, qs.stringify(this.client),axiosConfig)
          .then((response) => {
            console.log(response.data.status)
            // buat notifikasi sukses
            swal({
              title: "Request a Proposal",
              text: "Wait us for confirmation via email! Thank you " + this.client.nama,
              icon: "success",
            });
            this.modals.modal_proposal = false;
          })
          .catch((e) => {
            // buat notifikasi error 
            swal({
              title: "Request a Proposal",
              text: "Failed! Please try again!"+ e,
              icon: "warning",
            });
            console.error(e)
          });
        } else {
          // email tidak Valid
          swal({
            title: "Request a Proposal",
            text: "Failed! Please fill email correctly!",
            icon: "warning",
          });
        }  
      } else {
          // form tidak lengkap
          swal({
            title: "Request a Proposal",
            text: "Failed! Please fill the form completely!",
            icon: "warning",
          });
      }
    },
    validEmail: function (email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    }
  }
  // ,mounted () {
  //   //let api_url= 'http://localhost/api/index.php/pesanan';
  //   let api_url = 'https://admin.zeroinside.net/pesanan/';
  //   axios
  //     .get(api_url)
  //     .then(response => {
  //       console.log(response.data)
  //     })
  //     .catch(error => {
  //       console.log(error)
  //       this.errored = true
  //     })
  //     .finally(() => this.loading = false)
  // }
};
</script>
<style>
</style>
